<template>
  <span>
    <a-badge
      status="success"
      v-if="currentApprovalStep >= step && approvalStatus === 'APPROVED'"
    />
    <a-badge
      status="error"
      v-else-if="currentApprovalStep >= step && approvalStatus === 'REJECTED'"
    />
    <a-badge
      status="warning"
      v-else-if="
        status === 'EDITING' &&
        currentApprovalStep >= step &&
        approvalStatus === 'EDITING'
      "
    />
    <a-badge
      status="processing"
      v-else-if="status === 'SUBMITTING' && currentApprovalStep === step"
    />
    <a-badge status="default" v-else-if="currentApprovalStep < step" />
  </span>
</template>
<script>
export default {
  props: {
    approvalStatus: {
      type: String,
    },
    status: {
      type: String,
    },
    step: {
      type: Number,
      required: true,
    },
    currentApprovalStep: {
      type: Number,
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="css" scoped></style>
